import { useEnv } from '@library/composables/use-env'

export function getBaseUrl(): string {
  const { port, hostname, protocol } = window.location
  const { VITE_API_BASE_URL = '', VITE_BASE_URL } = useEnv()
  const url = `${protocol}//${hostname}:${port}`
  const apiBaseUrl = VITE_API_BASE_URL.replace(/^\//g, '')

  if (/^(http|https)/g.test(apiBaseUrl)) {
    return apiBaseUrl
  }

  if (VITE_BASE_URL) {
    return apiBaseUrl
      ? `${url}${VITE_BASE_URL}${apiBaseUrl}`
      : `${url}${VITE_BASE_URL}`
  }

  return apiBaseUrl ? `${url}/${VITE_API_BASE_URL}` : url
}
